import React, { Component} from 'react';
import Moment from 'react-moment';
import { Modal, Button } from 'react-bootstrap';
import SiteCount from './SiteCount';

export class Sites extends Component {
    static displayName = Sites.name;

    constructor(props) {
        super(props);
        this.state = { sites: [], loading: true, hidden: true, siteID: 0 };

        fetch('api/Site/GetSites')
            .then(response => response.json())
            .then(data => {
                this.setState({ sites: data, loading: false });
            });
        this.toggleHidden = this.toggleHidden.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    toggleHidden(ID) {
        this.setState({
            siteID: ID,
            hidden: !this.state.hidden
        });
    }
    handleClose() {
        this.setState({
            hidden: true
        });
    }

    MyVerticallyCenteredModal(props) {
        return (
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Modal heading
        </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h4>Centered Modal</h4>
                    <p>
                        Cras mattis consectetur purus sit amet fermentum. Cras justo odio,
                        dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac
                        consectetur ac, vestibulum at eros. 
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={props.onHide}>Close</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    render() {
        var tabledata =
            (<div>
                <table className='table table-responsive table-striped'>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Latitude/Longitude</th>
                            <th>Counter</th>
                            <th>Type</th>
                            <th>Installation Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.sites.sort((a, b) => Date.parse(a.installationDate) - Date.parse(b.installationDate)).map(site =>
                            <tr key={site.id}>
                                <td><button className="btn btn-link" onClick={() => this.toggleHidden(site.id)}> {site.name}</button></td>
                                <td>{site.latitude}, {site.longitude}</td>
                                <td>{site.counter}</td>
                                <td>{site.userType === "1" ? "Pedestrian" : ((site.userType === "12") ? ("Bicycle/Pedestrian") : ("Bicycle"))}</td>
                                <td><Moment format="MMMM DD, YYYY">{site.installationDate}</Moment></td>
                            
                            </tr>

                        )}
                    </tbody>
                </table>
                <Modal show={!this.state.hidden} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Site Count</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {console.log(this.state.siteID)}
                        <SiteCount siteID={this.state.siteID} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.handleClose}>Close</Button>
                    </Modal.Footer>
                </Modal>

                </div>);
        return (
            <div>
                <h1>Site data</h1>
                <p>This is a list of available sites.</p>
                {this.state.sites &&
                    tabledata
                }
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/Sites.js